import { render, staticRenderFns } from "./AssingPermisses.vue?vue&type=template&id=6829eb77"
import script from "./AssingPermisses.vue?vue&type=script&lang=js"
export * from "./AssingPermisses.vue?vue&type=script&lang=js"
import style0 from "./AssingPermisses.vue?vue&type=style&index=0&id=6829eb77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports